module.exports = __webpack_public_path__ + "static/media/healthians.ea3540fe.png";